import React from 'react';
import {useTranslation} from 'react-i18next';
import Copertina from '../Casino/Copertina';
import {Segnaposto} from '../Casino/Scheletro';
import useColonne from './colonne';

/**
 * LE COPERTINE A GRIGLIA CON «MOSTRA DI PIU'»: tante colonne uguali (dal
 * computer `colonne`, di serie dieci; sul telefono tre o quattro), `righe`
 * righe all'apertura e, sotto, il tasto che ne aggiunge altrettante finche'
 * ce ne sono. E' quello che usano le Griglie di giochi e i giochi sotto la
 * casella di ricerca.
 *
 * Le colonne le scrive la griglia (repeat(n, 1fr)): cosi' l'ultima riga
 * visibile e' sempre piena, senza il buco a destra di una griglia auto-fill.
 * Cambiando `ripartiDa` (la categoria o il testo cercato) si torna alle
 * righe dell'apertura.
 */
export default function GrigliaCelle({giochi, carica, righe, colonne, conAltre, ripartiDa, onApri, onTutti}) {
  const {t} = useTranslation();
  const griglia = React.useRef(null);
  const perRiga = useColonne(griglia, 4, colonne);
  const [quanteRighe, setQuanteRighe] = React.useState(righe);
  React.useEffect(() => { setQuanteRighe(righe); }, [righe, ripartiDa]);
  const visibili = giochi.slice(0, perRiga * quanteRighe);
  const altre = giochi.length - visibili.length;
  return (
    <>
      <div className={'vet-griglia-celle cas-griglia'} ref={griglia}
        style={{gridTemplateColumns: 'repeat(' + perRiga + ', minmax(0, 1fr))'}} aria-busy={carica || undefined}>
        {carica
          ? Array.from({length: perRiga * righe}, (_, i) => <Segnaposto key={i} inArrivo/>)
          : visibili.map((g) => <Copertina key={(g.sezione || '') + ':' + g.id} gioco={g} onApri={() => onApri(g)}/>)}
      </div>
      {!carica && altre > 0 && (
        <div className={'vet-griglia-piede'}>
          {conAltre
            ? <button type={'button'} className={'vet-griglia-altre'} onClick={() => setQuanteRighe((n) => n + righe)}>{t('Mostra di più')}</button>
            : <button type={'button'} className={'vet-griglia-altre'} onClick={onTutti}>{t('Vedi tutto')}</button>}
        </div>
      )}
    </>
  );
}
